import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageLoading = _resolveComponent("PageLoading")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_SuperPacmanInstallmentList = _resolveComponent("SuperPacmanInstallmentList")!
  const _component_SuperPacmanInstallmentListLegacy = _resolveComponent("SuperPacmanInstallmentListLegacy")!
  const _component_NoPayments = _resolveComponent("NoPayments")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading || (_ctx.superPacmanInstallment && !_ctx.showNoPayments && !_ctx.flagsSettled))
      ? (_openBlock(), _createBlock(_component_PageLoading, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.error)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 1,
          "country-prop": _ctx.country,
          "error-title": _ctx.errorTitle,
          "error-description": _ctx.errorDescription
        }, null, 8, ["country-prop", "error-title", "error-description"]))
      : (_ctx.superPacmanInstallment && !_ctx.showNoPayments && _ctx.flagsSettled && _ctx.useRedesign)
        ? (_openBlock(), _createBlock(_component_SuperPacmanInstallmentList, {
            key: 2,
            "installment-details": _ctx.superPacmanInstallment,
            onSelectInstallmentItem: _ctx.handleSelectInstallment,
            onOtherAmount: _ctx.handleOtherAmount
          }, null, 8, ["installment-details", "onSelectInstallmentItem", "onOtherAmount"]))
        : (_ctx.superPacmanInstallment && !_ctx.showNoPayments && _ctx.flagsSettled && !_ctx.useRedesign)
          ? (_openBlock(), _createBlock(_component_SuperPacmanInstallmentListLegacy, {
              key: 3,
              "installment-details": _ctx.superPacmanInstallment,
              "kasnet-qr-available": _ctx.kasnetQrAvailable,
              onSelectInstallmentItem: _ctx.handleSelectInstallment,
              onOtherAmount: _ctx.handleOtherAmount
            }, null, 8, ["installment-details", "kasnet-qr-available", "onSelectInstallmentItem", "onOtherAmount"]))
          : (_ctx.showNoPayments)
            ? (_openBlock(), _createBlock(_component_NoPayments, {
                key: 4,
                "country-prop": _ctx.country
              }, null, 8, ["country-prop"]))
            : _createCommentVNode("", true)
  ], 64))
}